import React from 'react';
import { ReactComponent as EyeOnIcon } from '../../icons/icon-eye-on.svg';
import { ReactComponent as EyeOffIcon } from '../../icons/icon-eye-off.svg';
import { ReactComponent as ApplePodcastIcon } from '../../icons/icon-apple-podcast.svg';
import { ReactComponent as AppleIcon } from '../../icons/icon-apple.svg';
import { ReactComponent as AudioWaveIcon } from '../../icons/icon-audio-wawe.svg';
import { ReactComponent as BookmarkIcon } from '../../icons/icon-bookmark.svg';
import { ReactComponent as BuildingIcon } from '../../icons/icon-building.svg';
import { ReactComponent as CalendarIcon } from '../../icons/icon-calendar.svg';
import { ReactComponent as CartIcon } from '../../icons/icon-cart.svg';
import { ReactComponent as ChatBubbleIcon } from '../../icons/icon-chat-bubble.svg';
import { ReactComponent as ChatIcon } from '../../icons/icon-chat.svg';
import { ReactComponent as CheckIcon } from '../../icons/icon-check.svg';
import { ReactComponent as ChefIcon } from '../../icons/icon-chef.svg';
import { ReactComponent as CircleAddIcon } from '../../icons/icon-circle-add.svg';
import { ReactComponent as CircleCheckIcon } from '../../icons/icon-circle-check.svg';
import { ReactComponent as CircleFacebookIcon } from '../../icons/icon-circle-facebook.svg';
import { ReactComponent as CircleIcon } from '../../icons/icon-circle.svg';
import { ReactComponent as ClockIcon } from '../../icons/icon-clock.svg';
import { ReactComponent as CloseIcon } from '../../icons/icon-close.svg';
import { ReactComponent as CocktailIcon } from '../../icons/icon-cocktail.svg';
import { ReactComponent as CopyIcon } from '../../icons/icon-copy.svg';
import { ReactComponent as DeliveryIcon } from '../../icons/icon-delivery.svg';
import { ReactComponent as DiamondEmptyIcon } from '../../icons/icon-diamond-empty.svg';
import { ReactComponent as DiamondFullIcon } from '../../icons/icon-diamond-full.svg';
import { ReactComponent as DocumentIcon } from '../../icons/icon-document.svg';
import { ReactComponent as DownloadIcon } from '../../icons/icon-download.svg';
import { ReactComponent as EditIcon } from '../../icons/icon-edit.svg';
import { ReactComponent as ExternalLinkIcon } from '../../icons/icon-external-link.svg';
import { ReactComponent as FsquareIcon } from '../../icons/icon-f-square.svg';
import { ReactComponent as FIcon } from '../../icons/icon-f.svg';
import { ReactComponent as FacebookIcon } from '../../icons/icon-facebook.svg';
import { ReactComponent as FigmaIcon } from '../../icons/icon-figma.svg';
import { ReactComponent as FolderIcon } from '../../icons/icon-folder.svg';
import { ReactComponent as FontIcon } from '../../icons/icon-font.svg';
import { ReactComponent as ForkSpoonIcon } from '../../icons/icon-fork-spoon.svg';
import { ReactComponent as GlobeIcon } from '../../icons/icon-globe.svg';
import { ReactComponent as GooglePodcastIcon } from '../../icons/icon-google-podcast.svg';
import { ReactComponent as GoogleIcon } from '../../icons/icon-google.svg';
import { ReactComponent as GooglePlay } from '../../icons/icon-google-play.svg';
import { ReactComponent as HeartIcon } from '../../icons/icon-heart.svg';
import { ReactComponent as InfoIcon } from '../../icons/icon-info.svg';
import { ReactComponent as InstagramIcon } from '../../icons/icon-instagram.svg';
import { ReactComponent as InvoiceIcon } from '../../icons/icon-invoice.svg';
import { ReactComponent as LinkIcon } from '../../icons/icon-link.svg';
import { ReactComponent as LinkedInIcon } from '../../icons/icon-linkedin.svg';
import { ReactComponent as LoaderIcon } from '../../icons/icon-loader.svg';
import { ReactComponent as LocationPinIcon } from '../../icons/icon-location-pin.svg';
import { ReactComponent as LockIcon } from '../../icons/icon-lock.svg';
import { ReactComponent as MailFullIcon } from '../../icons/icon-mail-full.svg';
import { ReactComponent as MailIcon } from '../../icons/icon-mail.svg';
import { ReactComponent as MenuIcon } from '../../icons/icon-menu.svg';
import { ReactComponent as MicMuteIcon } from '../../icons/icon-mic-mute.svg';
import { ReactComponent as MicIcon } from '../../icons/icon-mic.svg';
import { ReactComponent as MinusIcon } from '../../icons/icon-minus.svg';
import { ReactComponent as MoonIcon } from '../../icons/icon-moon.svg';
import { ReactComponent as NotificationIcon } from '../../icons/icon-notification.svg';
import { ReactComponent as OverflowDotsIcon } from '../../icons/icon-overflow-dots.svg';
import { ReactComponent as PlayIcon } from '../../icons/icon-play.svg';
import { ReactComponent as PlusIcon } from '../../icons/icon-plus.svg';
import { ReactComponent as PowerIcon } from '../../icons/icon-power.svg';
import { ReactComponent as QuotesIcon } from '../../icons/icon-quotes.svg';
import { ReactComponent as RectangleIcon } from '../../icons/icon-rectangle.svg';
import { ReactComponent as RefreshIcon } from '../../icons/icon-refresh.svg';
import { ReactComponent as RewindIcon } from '../../icons/icon-rewind.svg';
import { ReactComponent as SaleIcon } from '../../icons/icon-sale.svg';
import { ReactComponent as SandIcon } from '../../icons/icon-sand.svg';
import { ReactComponent as SearchIcon } from '../../icons/icon-search.svg';
import { ReactComponent as ShareIcon } from '../../icons/icon-share.svg';
import { ReactComponent as ShotcutIcon } from '../../icons/icon-shortcut.svg';
import { ReactComponent as SpotifyIcon } from '../../icons/icon-spotify.svg';
import { ReactComponent as SystemSettingsIcon } from '../../icons/icon-system-settings.svg';
import { ReactComponent as TagLineIcon } from '../../icons/icon-tag-line.svg';
import { ReactComponent as TiktokIcon } from '../../icons/icon-tiktok.svg';
import { ReactComponent as TwitterIcon } from '../../icons/icon-twitter.svg';
import { ReactComponent as UkrajineIcon } from '../../icons/icon-ukrajine.svg';
import { ReactComponent as UserIcon } from '../../icons/icon-user.svg';
import { ReactComponent as WarningIcon } from '../../icons/icon-warning.svg';
import { ReactComponent as WindowsIcon } from '../../icons/icon-windows.svg';
import { ReactComponent as YoutubeIcon } from '../../icons/icon-youtube.svg';
import { ReactComponent as ArrowDownLeftIcon } from '../../icons/icon-arrow-down-left.svg';
import { ReactComponent as ArrowDownIcon } from '../../icons/icon-arrow-down.svg';
import { ReactComponent as ArrowLeftIcon } from '../../icons/icon-arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../icons/icon-arrow-right.svg';
import { ReactComponent as ArrowUpLeftIcon } from '../../icons/icon-arrow-up-left.svg';
import { ReactComponent as ArrowUpRightIcon } from '../../icons/icon-arrow-up-right.svg';
import { ReactComponent as ArrowUpIcon } from '../../icons/icon-arrow-up.svg';
import { ReactComponent as BeBetterIcon } from '../../icons/icon-be-better.svg';
import { ReactComponent as BillionairesIcon } from '../../icons/icon-billionaires.svg';
import { ReactComponent as BreakingNewsIcon } from '../../icons/icon-breaking-news.svg';
import { ReactComponent as ChevronDownIcon } from '../../icons/icon-chevron-down.svg';
import { ReactComponent as ChevronLeftIcon } from '../../icons/icon-chevron-left.svg';
import { ReactComponent as ChevronRightIcon } from '../../icons/icon-chevron-right.svg';
import { ReactComponent as ChevronUpIcon } from '../../icons/icon-chevron-up.svg';
import { ReactComponent as CzBusinessIcon } from '../../icons/icon-cz-business.svg';
import { ReactComponent as GastroIcon } from '../../icons/icon-gastro.svg';
import { ReactComponent as IndividualIcon } from '../../icons/icon-individual.svg';
import { ReactComponent as LifeIcon } from '../../icons/icon-life.svg';
import { ReactComponent as LinkArrowLeftIcon } from '../../icons/icon-link-arrow-left.svg';
import { ReactComponent as LinkArrowRightIcon } from '../../icons/icon-link-arrow-right.svg';
import { ReactComponent as LovebrandIcon } from '../../icons/icon-lovebrand.svg';
import { ReactComponent as LoyaltyIcon } from '../../icons/icon-loyalty.svg';
import { ReactComponent as NavArrowLeftIcon } from '../../icons/icon-nav-arrow-left.svg';
import { ReactComponent as NavArrowRightIcon } from '../../icons/icon-nav-arrow-right.svg';
import { ReactComponent as RectangleChevronLeftIcon } from '../../icons/icon-rectangle-chevron-left.svg';
import { ReactComponent as RectangleChevronRightIcon } from '../../icons/icon-rectangle-chevron-right.svg';
import { ReactComponent as RectangleChevronUpIcon } from '../../icons/icon-rectangle-chevron-up.svg';
import { ReactComponent as TargetIcon } from '../../icons/icon-target.svg';
import { ReactComponent as TravelIcon } from '../../icons/icon-travel.svg';
import { ReactComponent as WomanIcon } from '../../icons/icon-woman.svg';
import { ReactComponent as WorldBusinessIcon } from '../../icons/icon-world-business.svg';
import { ReactComponent as ErrorIcon } from '../../icons/icon-error.svg';
import { ReactComponent as DiamondIcon } from '../../icons/icon-diamond.svg';
import { ReactComponent as SuccessIcon } from '../../icons/icon-success.svg';
import { ReactComponent as DefaultAvatarIcon } from '../../icons/icon-default-avatar.svg';
import { ReactComponent as IconForbesF } from '../../icons/icon-f-forbes-life.svg';
import { ReactComponent as IconForbesCircle } from '../../icons/icon-f-circle.svg';
import { ReactComponent as TopicHashtag } from '../../icons/icon-hashtag-topic.svg';
import { ReactComponent as FilterIcon } from '../../icons/icon-filter.svg';
import { ReactComponent as EcomArrowDownIcon } from '../../icons/icon-ecom-arrow-down.svg';
import { ReactComponent as EcomArrowUpIcon } from '../../icons/icon-ecom-arrow-up.svg';
import { ReactComponent as EcomCheckmarkIcon } from '../../icons/icon-ecom-checkmark.svg';
import { ReactComponent as EcomChevronDownIcon } from '../../icons/icon-ecom-chevron-down.svg';
import { ReactComponent as EcomChevronRightIcon } from '../../icons/icon-ecom-chevron-right.svg';
import { ReactComponent as EcomChevronLeftIcon } from '../../icons/icon-ecom-chevron-left.svg';

interface IconProps {
  name: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  classModifier?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = 'medium', classModifier = '' }) => {
  const getIconComponent = () => {
    switch (name) {
      case 'eye-on':
        return <EyeOnIcon className={`icon icon--${size}`} />;
      case 'eye-off':
        return <EyeOffIcon className={`icon icon--${size}`} />;
      case 'apple-podcast':
        return <ApplePodcastIcon className={`icon icon--${size}`} />;
      case 'apple':
        return <AppleIcon className={`icon icon--${size}`} />;
      case 'audio-wawe':
        return <AudioWaveIcon className={`icon icon--${size}`} />;
      case 'bookmark':
        return <BookmarkIcon className={`icon icon--${size} icon--${classModifier}`} />;
      case 'building':
        return <BuildingIcon className={`icon icon--${size}`} />;
      case 'calendar':
        return <CalendarIcon className={`icon icon--${size}`} />;
      case 'cart':
        return <CartIcon className={`icon icon--${size}`} />;
      case 'chat-bubble':
        return <ChatBubbleIcon className={`icon icon--${size}`} />;
      case 'chat':
        return <ChatIcon className={`icon icon--${size}`} />;
      case 'check':
        return <CheckIcon className={`icon icon--${size}`} />;
      case 'chef':
        return <ChefIcon className={`icon icon--${size}`} />;
      case 'circle-add':
        return <CircleAddIcon className={`icon icon--${size}`} />;
      case 'circle-check':
        return <CircleCheckIcon className={`icon icon--${size}`} />;
      case 'circle-facebook':
        return <CircleFacebookIcon className={`icon icon--${size}`} />;
      case 'circle':
        return <CircleIcon className={`icon icon--${size}`} />;
      case 'clock':
        return <ClockIcon className={`icon icon--${size}`} />;
      case 'close':
        return <CloseIcon className={`icon icon--${size}`} />;
      case 'cocktail':
        return <CocktailIcon className={`icon icon--${size}`} />;
      case 'copy':
        return <CopyIcon className={`icon icon--${size}`} />;
      case 'play':
        return <PlayIcon className={`icon icon--${size}`} />;
      case 'plus':
        return <PlusIcon className={`icon icon--${size}`} />;
      case 'power':
        return <PowerIcon className={`icon icon--${size}`} />;
      case 'quotes':
        return <QuotesIcon className={`icon icon--${size}`} />;
      case 'rectangle':
        return <RectangleIcon className={`icon icon--${size}`} />;
      case 'refresh':
        return <RefreshIcon className={`icon icon--${size}`} />;
      case 'rewind':
        return <RewindIcon className={`icon icon--${size}`} />;
      case 'sale':
        return <SaleIcon className={`icon icon--${size}`} />;
      case 'sand':
        return <SandIcon className={`icon icon--${size}`} />;
      case 'search':
        return <SearchIcon className={`icon icon--${size}`} />;
      case 'share':
        return <ShareIcon className={`icon icon--${size} `} />;
      case 'shortcut':
        return <ShotcutIcon className={`icon icon--${size}`} />;
      case 'spotify':
        return <SpotifyIcon className={`icon icon--${size}`} />;
      case 'system-settings':
        return <SystemSettingsIcon className={`icon icon--${size}`} />;
      case 'delivery':
        return <DeliveryIcon className={`icon icon--${size}`} />;
      case 'diamond-empty':
        return <DiamondEmptyIcon className={`icon icon--${size}`} />;
      case 'diamond-full':
        return <DiamondFullIcon className={`icon icon--${size}`} />;
      case 'document':
        return <DocumentIcon className={`icon icon--${size}`} />;
      case 'download':
        return <DownloadIcon className={`icon icon--${size}`} />;
      case 'edit':
        return <EditIcon className={`icon icon--${size}`} />;
      case 'external-link':
        return <ExternalLinkIcon className={`icon icon--${size}`} />;
      case 'fsquare':
        return <FsquareIcon className={`icon icon--${size}`} />;
      case 'f':
        return <FIcon className={`icon icon--${size}`} />;
      case 'facebook':
        return <FacebookIcon className={`icon icon--${size}`} />;
      case 'figma':
        return <FigmaIcon className={`icon icon--${size}`} />;
      case 'folder':
        return <FolderIcon className={`icon icon--${size}`} />;
      case 'font':
        return <FontIcon className={`icon icon--${size}`} />;
      case 'fork-spoon':
        return <ForkSpoonIcon className={`icon icon--${size}`} />;
      case 'globe':
        return <GlobeIcon className={`icon icon--${size}`} />;
      case 'google-podcast':
        return <GooglePodcastIcon className={`icon icon--${size}`} />;
      case 'google':
        return <GoogleIcon className={`icon icon--${size}`} />;
      case 'google-play':
        return <GooglePlay className={`icon icon--${size}`} />;
      case 'heart':
        return <HeartIcon className={`icon icon--${size}`} />;
      case 'info':
        return <InfoIcon className={`icon icon--${size}`} />;
      case 'instagram':
        return <InstagramIcon className={`icon icon--${size}`} />;
      case 'invoice':
        return <InvoiceIcon className={`icon icon--${size}`} />;
      case 'link':
        return <LinkIcon className={`icon icon--${size}`} />;
      case 'linkedin':
        return <LinkedInIcon className={`icon icon--${size}`} />;
      case 'loader':
        return <LoaderIcon className={`icon icon--${size}`} />;
      case 'location-pin':
        return <LocationPinIcon className={`icon icon--${size}`} />;
      case 'lock':
        return <LockIcon className={`icon icon--${size}`} />;
      case 'mail-full':
        return <MailFullIcon className={`icon icon--${size}`} />;
      case 'mail':
        return <MailIcon className={`icon icon--${size}`} />;
      case 'menu':
        return <MenuIcon className={`icon icon--${size}`} />;
      case 'mic-mute':
        return <MicMuteIcon className={`icon icon--${size}`} />;
      case 'mic':
        return <MicIcon className={`icon icon--${size}`} />;
      case 'minus':
        return <MinusIcon className={`icon icon--${size}`} />;
      case 'moon':
        return <MoonIcon className={`icon icon--${size}`} />;
      case 'notification':
        return <NotificationIcon className={`icon icon--${size}`} />;
      case 'overflow-dots':
        return <OverflowDotsIcon className={`icon icon--${size}`} />;
      case 'shotcut':
        return <ShotcutIcon className={`icon icon--${size}`} />;
      case 'tag-line':
        return <TagLineIcon className={`icon icon--${size}`} />;
      case 'tiktok':
        return <TiktokIcon className={`icon icon--${size}`} />;
      case 'twitter':
        return <TwitterIcon className={`icon icon--${size}`} />;
      case 'ukrajine':
        return <UkrajineIcon className={`icon icon--${size}`} />;
      case 'user':
        return <UserIcon className={`icon icon--${size}`} />;
      case 'warning':
        return <WarningIcon className={`icon icon--${size}`} />;
      case 'windows':
        return <WindowsIcon className={`icon icon--${size}`} />;
      case 'youtube':
        return <YoutubeIcon className={`icon icon--${size}`} />;
      case 'arrow-down-left':
        return <ArrowDownLeftIcon className={`icon icon--${size}`} />;
      case 'arrow-down':
        return <ArrowDownIcon className={`icon icon--${size}`} />;
      case 'arrow-left':
        return <ArrowLeftIcon className={`icon icon--${size}`} />;
      case 'arrow-right':
        return <ArrowRightIcon className={`icon icon--${size}`} />;
      case 'arrow-up-left':
        return <ArrowUpLeftIcon className={`icon icon--${size}`} />;
      case 'arrow-up-right':
        return <ArrowUpRightIcon className={`icon icon--${size}`} />;
      case 'arrow-up':
        return <ArrowUpIcon className={`icon icon--${size}`} />;
      case 'be-better':
        return <BeBetterIcon className={`icon icon--${size}`} />;
      case 'billionaires':
        return <BillionairesIcon className={`icon icon--${size}`} />;
      case 'breaking-news':
        return <BreakingNewsIcon className={`icon icon--${size}`} />;
      case 'chevron-down':
        return <ChevronDownIcon className={`icon icon--${size}`} />;
      case 'chevron-left':
        return <ChevronLeftIcon className={`icon icon--${size}`} />;
      case 'chevron-right':
        return <ChevronRightIcon className={`icon icon--${size}`} />;
      case 'chevron-up':
        return <ChevronUpIcon className={`icon icon--${size}`} />;
      case 'cz-business':
        return <CzBusinessIcon className={`icon icon--${size}`} />;
      case 'gastro':
        return <GastroIcon className={`icon icon--${size}`} />;
      case 'individual':
        return <IndividualIcon className={`icon icon--${size}`} />;
      case 'life':
        return <LifeIcon className={`icon icon--${size}`} />;
      case 'link-arrow-left':
        return <LinkArrowLeftIcon className={`icon icon--${size}`} />;
      case 'link-arrow-right':
        return <LinkArrowRightIcon className={`icon icon--${size}`} />;
      case 'lovebrand':
        return <LovebrandIcon className={`icon icon--${size}`} />;
      case 'loyalty':
        return <LoyaltyIcon className={`icon icon--${size}`} />;
      case 'nav-arrow-left':
        return <NavArrowLeftIcon className={`icon icon--${size}`} />;
      case 'nav-arrow-right':
        return <NavArrowRightIcon className={`icon icon--${size}`} />;
      case 'rectangle-chevron-left':
        return <RectangleChevronLeftIcon className={`icon icon--${size}`} />;
      case 'rectangle-chevron-right':
        return <RectangleChevronRightIcon className={`icon icon--${size}`} />;
      case 'rectangle-chevron-up':
        return <RectangleChevronUpIcon className={`icon icon--${size}`} />;
      case 'target':
        return <TargetIcon className={`icon icon--${size}`} />;
      case 'travel':
        return <TravelIcon className={`icon icon--${size}`} />;
      case 'woman':
        return <WomanIcon className={`icon icon--${size}`} />;
      case 'world-business':
        return <WorldBusinessIcon className={`icon icon--${size}`} />;
      case 'default-avatar':
        return <DefaultAvatarIcon className={`icon icon--${size}`} />;
      case 'error':
        return <ErrorIcon className={`icon icon--${size}`} />;
      case 'diamond':
        return <DiamondIcon className={`icon icon--${size}`} />;
      case 'success':
        return <SuccessIcon className={`icon icon--${size}`} />;
      case 'forbes-f-logo':
        return <IconForbesF className={`icon icon--${size}`} />;
      case 'f-circle':
        return <IconForbesCircle className={`icon icon--${size}`} />;
      case 'topic-hashtag':
        return <TopicHashtag className={`icon icon--${size}`} />;
      case 'filter':
        return <FilterIcon className={`icon icon--${size}`} />;
      case 'ecom-arrow-down':
        return <EcomArrowDownIcon className={`icon icon--${size}`} />;
      case 'ecom-arrow-up':
        return <EcomArrowUpIcon className={`icon icon--${size}`} />;
      case 'ecom-checkmark':
        return <EcomCheckmarkIcon className={`icon icon--${size}`} />;
      case 'ecom-chevron-down':
        return <EcomChevronDownIcon className={`icon icon--${size}`} />;
      case 'ecom-chevron-right':
        return <EcomChevronRightIcon className={`icon icon--${size}`} />;
      case 'ecom-chevron-left':
        return <EcomChevronLeftIcon className={`icon icon--${size}`} />;
      default:
        return null;
    }
  };

  const IconComponent = getIconComponent();

  return IconComponent ? <div className="icon-wrapper">{IconComponent}</div> : null;
};

export default Icon;
